import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0a1f2e] pt-20 pb-10 border-t border-white/5" role="contentinfo" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-118">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-119">
            <Link to="/" className="flex items-center space-x-2 mb-6 group" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png" alt="Vitality Logo" className="w-8 h-8" data-id="element-121" />
              <span className="text-lg font-bold text-white" data-id="element-122">Vitality</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-123">
              Investing in nature-inspired startups to create billion dollar
              solutions in essential industries.
            </p>
            <div className="flex space-x-4" data-id="element-124">
              <a href="https://www.linkedin.com/company/vitality-vf/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-vitalityTeal transition-colors" aria-label="Vitality on LinkedIn" data-id="element-125">
                <Linkedin className="w-5 h-5" data-id="element-126" />
              </a>
              <a href="mailto:contact@vitalityvf.com" className="text-gray-400 hover:text-vitalityTeal transition-colors" aria-label="Email Vitality" data-id="element-127">
                <Mail className="w-5 h-5" data-id="element-128" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-span-1" data-id="element-129">
            <h3 className="text-white font-semibold mb-6" data-id="element-130">Explore</h3>
            <ul className="space-y-4" data-id="element-131">
              {['Approach', 'Founders', 'Portfolio', 'Team'].map(item => <li key={item} data-id="element-132">
                  <Link to={`/${item.toLowerCase()}`} className="text-gray-400 hover:text-vitalityTeal transition-colors flex items-center group" data-id="element-133">
                    <span className="relative" data-id="element-134">
                      {item}
                      <span className="absolute bottom-0 left-0 w-0 h-px bg-vitalityTeal transition-all duration-300 group-hover:w-full" data-id="element-135" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* More Links */}
          <div className="col-span-1" data-id="element-136">
            <h3 className="text-white font-semibold mb-6" data-id="element-137">Company</h3>
            <ul className="space-y-4" data-id="element-138">
              {['Values', 'Updates', 'Contact'].map(item => <li key={item} data-id="element-139">
                  <Link to={`/${item.toLowerCase()}`} className="text-gray-400 hover:text-vitalityTeal transition-colors flex items-center group" data-id="element-140">
                    <span className="relative" data-id="element-141">
                      {item}
                      <span className="absolute bottom-0 left-0 w-0 h-px bg-vitalityTeal transition-all duration-300 group-hover:w-full" data-id="element-142" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact CTA */}
          <div className="col-span-1" data-id="element-143">
            <h3 className="text-white font-semibold mb-6" data-id="element-144">Get in Touch</h3>
            <p className="text-gray-400 text-sm mb-4" data-id="element-145">
              Want to build a world of vitality? We want to hear from you.
            </p>
            <Link to="/contact" className="inline-flex items-center text-vitalityTeal hover:text-bioLuminescentTeal transition-colors font-medium group" data-id="element-146">
              Contact Us
              <ArrowUpRight className="w-4 h-4 ml-1 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" data-id="element-147" />
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-148">
          <p data-id="element-149">
            &copy; {new Date().getFullYear()} Vitality Vida Partners, LLC. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-150">
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-151">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors" data-id="element-152">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}